// src/redux/auth/action/fetchTicketActions.jsx

import apiClient from '../../../apiClient/apiClient';
import {
    FETCH_TICKETS_REQUEST,
    FETCH_TICKETS_SUCCESS,
    FETCH_TICKETS_FAILURE,
    FETCH_TICKETS_RESET
} from '../constant/fetchTicketsConstant';

export const fetchTicketByEventId = (eventId) => async (dispatch) => {
    dispatch({ type: FETCH_TICKETS_REQUEST });

    try {
        // Add detailed logging for debugging
        console.log(`[DEBUG] Fetching tickets for event ID: ${eventId}`);
        
        // Fetch tickets specific to the event from the /events/:eventID/tickets endpoint
        const response = await apiClient.get(`/events/${eventId}/tickets`);
        
        // Log the full response for debugging
        console.log("[DEBUG] Full API Response:", response);
        
        // Check if data exists and has expected structure
        if (response.data) {
            console.log("[DEBUG] Fetched Tickets Data:", response.data);
            
            // Determine the structure of the data
            let ticketsArray = [];
            
            // Handle different possible response structures
            if (Array.isArray(response.data)) {
                ticketsArray = response.data;
            } else if (response.data.results && Array.isArray(response.data.results)) {
                ticketsArray = response.data.results;
            } else if (response.data.tickets && Array.isArray(response.data.tickets)) {
                ticketsArray = response.data.tickets;
            } else {
                console.error("[ERROR] Unexpected ticket data structure:", response.data);
                ticketsArray = []; // Default to empty array
            }
            
            console.log("[DEBUG] Processed Tickets Array:", ticketsArray);
            
            dispatch({
                type: FETCH_TICKETS_SUCCESS,
                payload: ticketsArray
            });
        } else {
            throw new Error("No data returned from API");
        }
    } catch (error) {
        console.error("[ERROR] Failed to fetch tickets:", error);
        dispatch({
            type: FETCH_TICKETS_FAILURE,
            payload: error.response?.data?.detail || error.message || 'Failed to fetch tickets',
        });
    }
};

export const resetFetchTicket = () => ({
    type: FETCH_TICKETS_RESET,
});
